<!-- App.svelte -->

<script>
    import { navigateTo } from 'svelte-router-spa'
    import TodoItem from "./components/TestItem.svelte";
    import { mmti_dict, pv } from "./store";

    let todos = [
        { id: 17, text: "잘 시간! 당신의 반려견은 혼자 자는 것보다는 당신의 체온을 느낄 수 있는 곳에서 함께 잡니다.", opacity: 1.0 },
        { id: 18, text: "종종 다른 개를 질투합니다.", opacity: 1.0 },
        { id: 19, text: "동물병원에 가야할 때, 당신의 강아지는 기절한 척을 하곤 합니다.", opacity: 1.0 },
        { id: 20, text: "당신의 반려견은 최소 견생 n회차입니다.", opacity: 1.0 },
        { id: 21, text: "당신이 기분이 안 좋아보여도 속도 모르고 장난을 칩니다.", opacity: 1.0 },
        { id: 22, text: "당신의 반려견은 계획이 다 있습니다.", opacity: 1.0 },
        { id: 23, text: "처음보는 사람 또는 개를 만나면 낯을 가립니다.", opacity: 1.0 },
        { id: 24, text: "털에 지저분한 것이 묻으면 떼어줄 때 까지 기다립니다.", opacity: 0.0 },
    ];

    $pv = 16;
    let i = 0;
    let test_id = '';
    for (i = 0; i < todos.length; i++) {
        test_id = 'mmti' + String(todos[i].id)
        if (test_id in $mmti_dict) {
            $pv += 1;
        }
    } 


    function clickContinue() {
        let allPass = true;

        for (let i = 0; i < todos.length; i++) {
            let todo = todos[i];
            let test_id = 'mmti' + String(todo.id);

            if (test_id in $mmti_dict) {
                todos[i]['textColor'] = 'black';
                todos[i]['textAni'] = '';
            } else {
                allPass = false;
                todos[i]['textColor'] = '#ad1305';
                todos[i]['textAni'] = 'text_shake';

                setTimeout(function(){
                    todos[i]['textAni'] = '';
                }, 500);
            }
        }

        if (allPass) {
            navigateTo('test4');
        } else {
            alert('체크 안 한 항목이 있는지 한 번 더 확인해주세요.');
        } 
    }

</script>

<style lang="scss">
.hero-body {
    background: #f5f5f6;   
}

body, html {
    -webkit-tap-highlight-color: transparent; 
}
.progress {
  border-radius: 0;
}

.progress.is-mmti::-webkit-progress-value {
  background-color: rgba($color: #36765a, $alpha: 1.0);
}

.progress.is-mmti::-moz-progress-bar {
  background-color:rgba($color: #36765a, $alpha: 1.0);
}

.progress.is-mmti::-ms-fill {
  background-color:rgba($color: #36765a, $alpha: 1.0);
}

.progress.is-mmti:indeterminate {
  background-image: linear-gradient(to right, rgba($color: #36765a, $alpha: 1.0) 30%, #ededed 30%);
}

</style>

<html class="has-navbar-fixed-top" style="padding-top: 0">
<body>


<nav class="navbar is-fixed-top" style="background: #f5f5f6; min-height: 0;">
<progress class="progress is-mmti" value="{$pv}" max="40"></progress>
</nav>


<section class="hero is-fullheight">
<div class="hero-body">
<div class="container has-text-centered">
<div class="columns is-desktop">

    <div class="column">

    {#each todos as todo (todo.id)}
    <TodoItem {todo} />
    {/each}

    <div class="container">
    <figure class="image container is-128x128" style="width: 150px; cursor: pointer;" on:click={() => clickContinue() }><img src="/next.png">
    <h1 class ="title is-6 is-overlay mt-4 mr-5 has-text-white"><p>다음</p></h1>
    </figure>
    </div>

</div>
</div>
</div>
</section>
</body>
</html>
